import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';
import Config from '../../config';

export const fetchDatabaseLogHeaders = async ({ from, to, note }) => await fetch(
  Config.endpoints.DB_LOG_HEADERS
    .replace(/:from/, from.toISOString())
    .replace(/:to/, to.toISOString())
    .replace(/:note/, note)
)
  .then(handleErrors({ errorMessage: 'Fetching database log headers failed' }))
  .then(parseAsJson);

export const fetchDatabaseLogDetail = async ({ headerId, note }) => await fetch(
  Config.endpoints.DB_LOG_DETAIL
    .replace(/:headerId/, headerId)
    .replace(/:note/, note)
)
  .then(handleErrors({ errorMessage: 'Fetching database log headers failed' }))
  .then(parseAsJson);
